import { getMainRoomConfiguration } from '../api/configuration';

const initialRoomConfig = {
    roomName: null,
    hideUserNames: false, 
    restrictControlsForAnonymousUsers: true, 
    allowUserRecordings: false,
    allowedLoginDomains: [],
    enableLoginDomains: false
}

const state = () => ({
    currentRoom: Object.assign({}, initialRoomConfig)
})

const actions = {
    async getMainRoomConfig ({ commit }, { roomName }) {
      const mainRoomConfig = await getMainRoomConfiguration(roomName);
      if(mainRoomConfig.data){
         let currentRoomConfig = mainRoomConfig.data;
         currentRoomConfig.roomName = roomName;
         commit('updateMainRoomConfig', currentRoomConfig);
      }
    }
  }

const mutations = {
    updateMainRoomConfig(state, mainRoomConfig) {
        state.currentRoom = {...state.currentRoom, ...mainRoomConfig};
    },

    updateMainRoomName(state, roomName){
        if(roomName) state.currentRoom = {...state.currentRoom, roomName};
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
